/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The call statut:
 *   * DEFAULT
 *   * NORMAL
 */
export enum CallStatus {
  DEFAULT = 'DEFAULT',
  NORMAL = 'NORMAL'
}
